import React from 'react'


import FAQRow from '../components/faq-row'
import Footer from '../components/footer'
import Navbar from '../components/navbar'
import FormContact from '../components/form'
import './contact.css'

import HelmetWidget from '../components/helmet'

const Contact = () => {
	return (
		<div className="contact-container">
			<HelmetWidget
				pageTitle="Contact"
				description="Contactez Bureau Preventicas pour plus d'informations sur nos formations en amainte, sécurité incendie, en premiers secours et en prévention des risques professionnels."
				path="contact"
			>
			</HelmetWidget>
			<Navbar></Navbar>
			<div className="contact-container1">
				<div className="contact-container2">
					<h1 className="contact-text page-title">Une question ? Contactez-nous</h1>
					<FormContact></FormContact>
				</div>
				<div className="contact-info-section">
					<div className="contact-info-container">
						<div className="contact-info-card">
							<h3 className="contact-info-title">📍 Adresse</h3>
							<p>22 Av. de la Division Leclerc</p>
							<p>93000 Bobigny</p>
						</div>
						<div className="contact-info-card">
							<h3 className="contact-info-title">📞 Téléphone</h3>
							<p><a href="tel:0143932223">01 43 93 22 23</a></p>
							<p><a href="tel:0760403446">07 60 40 34 46</a></p>
						</div>
						<div className="contact-info-card">
							<h3 className="contact-info-title">✉️ Email</h3>
							<p><strong>Pôle formation :</strong></p>
							<p><a href="mailto:formations@bureaupreventicas.fr">formations@bureaupreventicas.fr</a></p>
							<p><strong>Comptabilité :</strong></p>
							<p><a href="mailto:comptabilite@bureaupreventicas.fr">comptabilite@bureaupreventicas.fr</a></p>
						</div>
						<div className="contact-info-card">
							<h3 className="contact-info-title">🕒 Horaires</h3>
							<p>Lundi au Vendredi</p>
							<p>09:00 - 17:00</p>
						</div>
					</div>
				</div>
				<div className="contact-faq">
					<div className="contact-faq-container faqContainer">
						<div className="contact-faq1">
							<div className="contact-container5">
								<span>FAQ</span>
								<h2 className="heading2">Questions fréquentes</h2>
							</div>
							<div className="contact-container6">
								<FAQRow
									answer="Bureau Preventicas dispense des formations en santé et sécurité au travail, en premiers secours et en prévention des risques professionnels."
									question="Quels sont les types de formations dispensées par Bureau Preventicas?"
								></FAQRow>
								<FAQRow
									answer="Bureau Preventicas propose des formations de qualité dispensées par des professionnels expérimentés, des infrastructures modernes et un suivi personnalisé pour chaque apprenant ainsi qu'un diplôme reconnu dans la profession."
									question="Quels sont les avantages de choisir Bureau Preventicas pour sa formation en sécurité?"
								></FAQRow>
								<FAQRow
									answer="Pour vous inscrire à une formation chez Bureau Preventicas, vous pouvez remplir le formulaire de contact sur notre site web, nous contacter directement par téléphone, ou en vous déplaçant directement dans nos locaux."
									question="Comment puis-je m'inscrire à une formation chez Bureau Preventicas?"
								></FAQRow>
								<FAQRow
									answer="Vous pouvez nous contacter en remplissant le formulaire de contact sur notre site web, en nous appelant au numéro indiqué ou en venant directement à notre centre de formation situé au 22 avenue de la Division Leclerc 93000 Bobigny."
									question="Comment puis-je contacter Bureau Preventicas pour plus d'informations?"
								></FAQRow>
								<FAQRow
									answer="En tant que particulier, vous pouvez financer votre formation grâce à France Travail, à votre CPF ou avec une aide de la région. En tant qu'entreprise, vous pouvez bénéficier d'une prise en charge par votre OPCO (Constructys, OPCO Atlas, AFDAS, etc...)."
									question="Comment puis-je financer une formation chez Bureau Preventicas?"
								></FAQRow>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
	)
}

export default Contact
